import {
  EInvoiceAddressSchemeType,
  EInvoicingAddress,
  EntityType,
  getDefaultAddressSchemeTypeByCountry,
} from '@components'

import { ReactElement, useCallback } from 'react'

import { useXRechnungEInvoicingAddressForm } from '../../../../../../contexts/xRechnungEInvoicingAddressFormContext'

export const XRechnungEInvoicingAddress = (): ReactElement => {
  const { countryId, xRechnungEInvoicingAddressForm } = useXRechnungEInvoicingAddressForm()
  const {
    formState: { errors },
    setValue,
    trigger,
    watch,
  } = xRechnungEInvoicingAddressForm

  const [ean, eInvoiceScheme, publicEntityRoutingEnabled] = watch([
    'ean',
    'eInvoiceScheme',
    'publicEntityRoutingEnabled',
  ])

  const eInvoiceAddressInputErrorMessage = errors.ean?.message

  const handleEInvoiceAddressInputChange = useCallback(
    (newAddress?: string) => {
      setValue('ean', newAddress)

      if (eInvoiceAddressInputErrorMessage) {
        trigger('ean')
      }
    },
    [eInvoiceAddressInputErrorMessage, setValue, trigger],
  )

  const handleEInvoiceAddressSchemeTypeChange = useCallback(
    (newSchemeType?: EInvoiceAddressSchemeType) => {
      setValue('eInvoiceScheme', newSchemeType)
      handleEInvoiceAddressInputChange('')
    },
    [handleEInvoiceAddressInputChange, setValue],
  )

  const handleEInvoiceAddressEntityTypeChange = useCallback(
    (newEntityType?: EntityType) => {
      const isPublicEntity = newEntityType === EntityType.Public
      setValue('publicEntityRoutingEnabled', isPublicEntity)

      const defaultSchemeType = getDefaultAddressSchemeTypeByCountry(isPublicEntity, countryId)
      handleEInvoiceAddressSchemeTypeChange(defaultSchemeType)
    },
    [countryId, handleEInvoiceAddressSchemeTypeChange, setValue],
  )

  return (
    <EInvoicingAddress
      address={ean}
      countryId={countryId}
      eInvoiceAddressInputErrorMessage={eInvoiceAddressInputErrorMessage}
      entityType={publicEntityRoutingEnabled ? EntityType.Public : EntityType.Private}
      onEInvoiceAddressInputChange={handleEInvoiceAddressInputChange}
      onEInvoiceAddressSchemeTypeChange={handleEInvoiceAddressSchemeTypeChange}
      onEInvoiceAddressEntityTypeChange={handleEInvoiceAddressEntityTypeChange}
      schemeType={eInvoiceScheme || ''}
      size="sm"
    />
  )
}
